import { TfiReload } from "react-icons/tfi";
import { MdLockOutline } from "react-icons/md";
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import * as affl from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import md5 from "md5";
import axios from "axios";
import Swal from "sweetalert2";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { config } from "../CommonUtils/CommonURLS";
import { getTokenExpiry } from "../CommonUtils/TimeUtility";
import { broadcastNewLogin } from "../CommonUtils/SessionManager";
import { CommonAxiosGet, CommonAxiosPostLogin } from "../CommonUtils/CommonAxios";
import { IoMdLogIn } from "react-icons/io";

import {
    FaEye, FaEyeSlash, FaRegUser,
    FaCogs, // Engineering
    FaCapsules, // Pharmacy
    FaGraduationCap, // Degree
    FaChalkboardTeacher, // B.Ed
    FaRunning, // B.P.Ed
    FaBalanceScale, // Law
    FaBriefcase, // MBA
    FaLaptopCode, // MCA
    FaTools, // Polytechnic
} from "react-icons/fa";
import { clearAuthSession } from "../CommonUtils/RequireAuth";

// const TICKER_ITEMS = [
//     "AP EAMCET 2025 Counselling Schedule will be Available Soon",
//     "APICET 2025 Rank Cards Will be Updated Soon",

// ];
const TICKER_ITEMS = [
    <>
        ** To access the NOC system, please use your Jnanabhumi or Affiliation login credentials. **
        {/* Kindly note that Affiliation for the Academic Year 2026–27 for degree colleges operating in leased
        buildings will be opened only after the EOP application submitted in the NOC portal. */}


        Kindly note that affiliation for the Academic Year 2026–27 for degree colleges operating in leased buildings shall be processed only after the EOP application
        submitted in the NOC portal is duly verified and approved by the competent authority.

        {/* <a
            href="https://che.apcfss.in/"
            target="_blank"
            rel="noopener noreferrer"
            className="aphe-ticker-link"
        >
            NOC Portal
        </a> */}
    </>,
];
const STATS = [
    { num: "2,500+", label: "Colleges" },
    { num: "7+", label: "Streams" },
    { num: "80k+", label: "Faculties" }
];

const NAV_LINKS = ["Website Policies", "Go's", "About", "Notifications", "Affiliation 2026 - 27"];

const COURSES = [
    {
        key: "deg",
        name: "Degree",
        desc: "UG / PG arts, science and commerce programmes",
        btn: "#8b46c9",
        bg: "#f3ebfd",
        clgType: [118, 145, 102],
        icon: <FaGraduationCap size={28} color="#8b46c9" />,
    },
    {
        key: "poly",
        name: "Polytechnic",
        desc: "Diploma in engineering & technical programmes",
        btn: "#0b8fbd",
        bg: "#e3f6fd",
        clgType: [115],
        icon: <FaTools size={28} color="#0b8fbd" />,
    },
    {
        key: "eng",
        name: "Engineering",
        desc: "B.Tech. / M.Tech. Programmes",
        btn: "#2563eb",
        bg: "#eef3fe",
        clgType: [113, 124, 102],
        icon: <FaCogs size={28} color="#2563eb" />,
    },
    {
        key: "pha",
        name: "Pharmacy",
        desc: "B.Pharmacy / D.Pharmacy Programmes",
        btn: "#0d9e76",
        bg: "#e6f6f2",
        clgType: [135, 138],
        icon: <FaCapsules size={28} color="#0d9e76" />,
    },

    // {
    //     key: "bed",
    //     name: "B.Ed",
    //     desc: "Bachelor of Education teacher training programme",
    //     btn: "#d96119",
    //     bg: "#fdf0e8",
    //     clgType: [104, 122],
    //     icon: <FaChalkboardTeacher size={28} color="#d96119" />
    // },
    // {
    //     key: "bped",
    //     name: "B.P.Ed",
    //     desc: "Bachelor of Physical Education & sports training",
    //     btn: "#d63039",
    //     bg: "#fdeaea",
    //     clgType: [104, 122],
    //     icon: <FaRunning size={28} color="#d63039" />
    // },
    {
        key: "law",
        name: "Law",
        desc: "LLB / LLM Programmes",
        btn: "#c08a10",
        bg: "#fdf6e3",
        clgType: [131, 142],
        icon: <FaBalanceScale size={28} color="#c08a10" />,
    },
    {
        key: "mba",
        name: "MBA",
        desc: "Master of Business Administration Programmes",
        btn: "#ff4d94",
        bg: "#ffe6f0",
        clgType: [111, 147],
        icon: <FaBriefcase size={28} color="#ff4d94" />,
    },
    {
        key: "mca",
        name: "MCA",
        desc: "Master of Computer Application Programmes",
        btn: "#6b7280",
        bg: "#f3f4f6",
        clgType: [136],
        icon: <FaLaptopCode size={28} color="#6b7280" />,
    },
];




function Ticker() {
    const doubled = [...TICKER_ITEMS];
    return (
        <div className="aphe-ticker-wrap">
            <div className="aphe-ticker-label">Latest Updates</div>
            <div className="aphe-ticker-track">
                <div className="aphe-ticker-inner">
                    {doubled.map((item, i) => (
                        <span key={i} className="aphe-ticker-item">
                            <span className="aphe-ticker-dot" />
                            {item}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
}


const handleRegister = () => {
    window.location.href = "/NewCollegeRegister";
};


// eslint-disable-next-line react/prop-types
function CourseCard({ course, onLogin, onRegister }) {
    // const isAllowed = ["deg", "poly"].includes(course.key);
    const isAllowed = ["deg"].includes(course.key);


    const isDegree = course.key === "deg";

    return (
        <div className={`aphe-card ${course.key}`}>

            <div className="aphe-icon-wrap" style={{ background: course.bg }}>
                {course.icon}
            </div>

            <div className="aphe-course-name">{course.name}</div>
            <div className="aphe-course-desc">{course.desc}</div>


            <button
                className="aphe-login-btn"
                style={{ background: course.btn }}
                disabled={!isAllowed}
                onClick={(e) => {
                    e.stopPropagation();
                    if (isAllowed) onLogin(course);
                }}
            >
                Login <IoMdLogIn size={25} />

            </button>


        </div>
    );
}
export default function Testlogin() {
    const [modal, setModal] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState(null); // ✅ tracks which course login opened
    const [showPassword, setShowPassword] = useState(false);
    const [captcha, setCaptcha] = useState(null);
    const [captchaInput, setCaptchaInput] = useState("");
    const hasFetchedData = useRef(false);
    // const [showImageModal, setShowImageModal] = useState(false);
    // const [showNote, setShowNote] = useState(true);


    // Replace single showNote state with a modal "mode"
    const [showImageModal, setShowImageModal] = useState(false);
    const [modalMode, setModalMode] = useState("gos"); // "gos" | "notifications
    let navigate = useNavigate();

    const handleCloseImageModal = () => {
        setShowImageModal(false);
    };

    const [clgType, setClgType] = useState([]);
    const validationSchema = Yup.object({
        userId: Yup.string().required("User ID is required").nullable(),
        password: Yup.string().required("Password is required").nullable(),
        captcha: Yup.string().required("Captcha is required").nullable(),
    });

    const formik = useFormik({
        initialValues: {
            userId: "",
            password: "",
            captcha: "",
        },
        validationSchema,
        onSubmit: (values, { setSubmitting, setFieldValue }) => {
            const isEightDigitNumber = /^\d{8,}$/.test(values.userId);
            const isNewColl = values.userId?.startsWith("2026");
            const isInspectionUser = values.userId?.startsWith("noc_");
            const loginType = selectedCourse?.name === "Admin" ? "university" : isNewColl ? "new_coll" : isInspectionUser ? "inspection" : selectedCourse?.type === "inspection" && isEightDigitNumber ? "scrutiny" : "College";

            const body = {
                userId: values.userId,
                userPassword: md5(values.password.trim()),
                captcha: values.captcha,
                captchaId: captchaInput,
                loginType,

                clgType: loginType === "scrutiny" || selectedCourse?.name === "Admin" || selectedCourse?.name === "Inspecttio" ? [] : clgType,
                acYear: "2026-27",
            };

            CommonAxiosPostLogin(config.url.FAC_URL + "auth/authenticate", body).then((response) => {
                if (response?.data?.responseCode === "01") {
                    var decodedToken = jwtDecode(response?.data?.accessToken);

                    const tokenExpiry = getTokenExpiry(response.data.accessToken);
                    const refreshExpiry = getTokenExpiry(response.data.refreshToken);

                    sessionStorage.setItem("token", response?.data?.accessToken);
                    sessionStorage.setItem("refreshToken", response?.data?.refreshToken);

                    sessionStorage.setItem("tokenTime", tokenExpiry);
                    sessionStorage.setItem("refreshTokenTime", refreshExpiry);


                    sessionStorage?.setItem("Group_Code", decodedToken?.user_gr_code);
                    sessionStorage.setItem("user_id", decodedToken?.user_id);
                    sessionStorage.setItem("is_changed", decodedToken?.is_changed);
                    sessionStorage.setItem("role_id", decodedToken?.role);
                    sessionStorage.setItem("user_name", decodedToken?.empl_first_name);
                    sessionStorage.setItem("Login_Type", decodedToken?.login_type);
                    sessionStorage.setItem("LOGIN", response?.data?.loginType);
                    broadcastNewLogin();
                    CommonAxiosGet(config.url.FAC_URL + "getServices").then((res) => {
                        if (res?.data?.scode === "01") {
                            sessionStorage.setItem("menuData", JSON.stringify(res.data.services));

                            // navigate("/NocDashboard");
                            if (String(decodedToken?.user_gr_code) === "10") {
                                navigate("/NocDashboard");
                            } else {
                                navigate("/home");
                            }
                        }
                    });
                } else {
                    Swal.fire({
                        text: response?.data?.sdesc,
                        icon: "error",
                        confirmButtonText: "OK",
                        backdrop: false,
                    }).then(() => {
                        if (response?.data?.sdesc === "Invalid Captcha") {
                            setFieldValue("captcha", "");
                            GetCaptcha();
                        }
                        if (response?.data?.sdesc === "Invalid login credentials! Try again." || response?.data?.sdesc === "Please Check  type of College") {
                            // setFieldValue("userId", "");
                            // setFieldValue("password", "");
                            // document.getElementById("loginPassword").value = null;
                            // setFieldValue("captcha", "");
                            GetCaptcha();
                        }
                    });
                }
                setSubmitting(false);
            });
        },
    });

    function GetCaptcha() {
        let url = config.url.FAC_URL + `captcha`;
        axios.get(url).then((res) => {
            if (res?.data?.scode === "01") {
                setCaptcha(res?.data?.sdesc);
                setCaptchaInput(res?.data?.captchaId);
            } else {
                setCaptcha("");
                setCaptchaInput("");
            }
        });
    }

    useEffect(() => {
        sessionStorage.clear();
        localStorage.clear();
        // If user returns to login/home through browser history, treat it as a fresh session.
        clearAuthSession();
        // setModalMode("gos");   
        setModalMode("pageload")     // ✅ always GOs on load
        setShowImageModal(true);

        if (!hasFetchedData.current) {
            GetCaptcha();
            hasFetchedData.current = true;
        }
    }, []);

    const handleLogin = (course) => {
        if (course === "university") {
            setSelectedCourse({
                name: "Admin",
            });

            setClgType("university");
        } else if (course === "inspection") {
            setSelectedCourse({
                name: "Inspection",
                type: "inspection",
            });
            setClgType(course.clgType || []);
        } else {
            setSelectedCourse({
                ...course,
                type: "college",
            });

            setClgType(course.clgType || []);
        }

        formik.resetForm();
        GetCaptcha();
        setModal(true);
    };

    const handleModalClose = () => {
        setModal(false);
        setSelectedCourse(null);
        formik.resetForm();
    };

    {
        /* Buttons Grid */
    }

    const btnStyle = {
        padding: "10px",
        borderRadius: "6px",
        fontWeight: "500",
        cursor: "pointer",
        textAlign: "left", // ✅ Text from left
        width: "100%", // ✅ Full width button
    };
    const pdfButtons = [
        {
            label: "📙 EoP Notification",
            file: "/Extension of Permission (EoP) Note.pdf",
            bg: "#fff8e1",
            color: "#e65100",
            border: "#ffe082",
        },
        {
            label: "📓 EoP Guidelines",
            file: "/EopGuidelines.pdf",
            bg: "#fce4ec",
            color: "#880e4f",
            border: "#f48fb1",
        },
        {
            label: "📗 Change of Management Notification",
            file: "/Change of Management Note.pdf",
            bg: "#e8f5e9",
            color: "#1b5e20",
            border: "#a5d6a7",
        },
        {
            label: "📘 Change of Management Guidelines",
            file: "/change-management-guidelines.pdf",
            bg: "#e3f2fd",
            color: "#0d47a1",
            border: "#90caf9",

        },
        {
            label: "📓 Shifting Notification",
            file: "/Shifting Note.pdf",

            // ✅ Changed to Purple Theme
            bg: "#f3e5f5",
            color: "#4a148c",
            border: "#ce93d8",
        },
        {
            label: "📕 Shifting Guidelines",
            file: "/Shifting-Guidelines.pdf",
            bg: "#e1f5fe",
            color: "#01579b",
            border: "#81d4fa",
        },
        { label: "Extension of permission/Change of Management/Shifting Additional  Guidelines", file: "/EOPExtention.pdf", bg: "#e3f2fd", color: "#1565C0", border: "#90caf9" },
        {
            label: "📓 Conversion of Program Notification",
            file: "/COPNote.pdf",
            bg: "#e1f5fe",
            color: "#01579b",
            border: "#81d4fa",
        },
        {
            label: "📕 Conversion of Program Guidelines",
            file: "/COPGuidelines.pdf",
            bg: "#e1f5fe",
            color: "#01579b",
            border: "#81d4fa",
        },

    ];

    const [showAbout, setShowAbout] = useState(false);

    const goPdfButtons = [
        // { label: "Extension of permission/Change of Management/Shifting Additional  Guidelines", file: "/EOPExtention.pdf", bg: "#e3f2fd", color: "#1565C0", border: "#90caf9" },

        { label: "GO Ms.No.20", file: "/20.pdf", bg: "#e3f2fd", color: "#1565C0", border: "#90caf9" },
        { label: "GO Ms.No.21", file: "/21.pdf", bg: "#e3f2fd", color: "#1565C0", border: "#90caf9" },
        { label: "GO Ms.No.33", file: "/33.pdf", bg: "#e3f2fd", color: "#1565C0", border: "#90caf9" },
        { label: "GO Ms.No.36", file: "/36.PDF", bg: "#e3f2fd", color: "#1565C0", border: "#90caf9" },
    ];



    const pageLoadButtons = [

        {
            label: "New Registrations for EOP, Change of Management and Shifting are closed.\n\nPlease check your college logins for Deficiency Letters / Approval Orders.",
            bg: "#feece1",
            color: "#9b1301",
            border: "#e4fa81",
        },
        {
            label: "📓 Conversion of Program Notification",
            file: "/COPNote.pdf",
            bg: "#e1f5fe",
            color: "#01579b",
            border: "#81d4fa",
        },
        {
            label: "📕 Conversion of Program Guidelines",
            file: "/COPGuidelines.pdf",
            bg: "#e1f5fe",
            color: "#01579b",
            border: "#81d4fa",
        },

    ];
    const buttonsToShow =
        modalMode === "gos"
            ? goPdfButtons
            : modalMode === "notifications"
                ? pdfButtons
                : pageLoadButtons;

    return (
        <div className="aphe-root">
            <header className="aphe-header">
                <div className="aphe-logo-area">
                    <affl.Modal show={modal} onHide={handleModalClose} className="modal fade login-modal-page" size="" backdrop="static">
                        <affl.Modal.Header closeButton>
                            <div>
                                <h1 className="modal-title fs-5">{selectedCourse?.name ? `${selectedCourse.name} Login` : "Login"}</h1>
                                <p className="mb-0" style={{ fontSize: "0.85rem", color: "#6c757d" }}>
                                    {selectedCourse?.desc ? selectedCourse.desc : "Welcome back to NOC  application!"}
                                </p>
                            </div>
                        </affl.Modal.Header>

                        <affl.Modal.Body>
                            {selectedCourse && (
                                <div
                                    className="d-flex align-items-center gap-2 mb-3 p-2 rounded"
                                    style={{
                                        background: selectedCourse.bg,
                                        border: `1px solid ${selectedCourse.btn}22`,
                                    }}
                                >
                                    <div style={{ flexShrink: 0 }}>{selectedCourse.icon}</div>
                                    <div>
                                        <div style={{ fontWeight: 600, color: selectedCourse.btn, fontSize: "0.95rem" }}>
                                            {/* {selectedCourse.name} Portal */}
                                            {clgType !== "university" && `${selectedCourse.name} Portal`}
                                        </div>
                                        <div style={{ fontSize: "0.78rem", color: "#555" }}>{selectedCourse.desc}</div>
                                    </div>
                                </div>
                            )}

                            <FormikProvider value={formik}>
                                <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit}>
                                    {/* User ID */}
                                    <div className="mb-3">
                                        <label htmlFor="userId" className="form-headings">
                                            User ID
                                        </label>
                                        <div className="input-group">
                                            <span className="input-group-text">
                                                <FaRegUser />
                                            </span>
                                            <Field type="text" name="userId" className="form-control" placeholder="Enter User ID" autoComplete="new-password" maxLength="16" />
                                        </div>
                                        <ErrorMessage name="userId" className="text-danger" component="div" />
                                    </div>

                                    {/* Password */}
                                    <div className="mb-3">
                                        <label htmlFor="loginPassword" className="form-headings">
                                            Password
                                        </label>
                                        <div className="input-group" style={{ position: "relative" }}>
                                            <span className="input-group-text">
                                                <MdLockOutline />
                                            </span>
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                name="password"
                                                className="form-control"
                                                placeholder="Password"
                                                autoComplete="new-password"
                                                maxLength="20"
                                                id="loginPassword"
                                                style={{ paddingRight: "40px" }}
                                                onChange={formik.handleChange}
                                                value={formik.values.password}
                                            />
                                            <span
                                                role="button"
                                                tabIndex={0}
                                                onClick={() => setShowPassword(!showPassword)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter" || e.key === " ") setShowPassword(!showPassword);
                                                }}
                                                style={{
                                                    position: "absolute",
                                                    right: "10px",
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    cursor: "pointer",
                                                    zIndex: 5,
                                                }}
                                            >
                                                {showPassword ? <FaEye /> : <FaEyeSlash />}
                                            </span>
                                        </div>
                                        <ErrorMessage name="password" className="text-danger" component="div" />
                                    </div>

                                    {/* Captcha */}
                                    <div className="mb-3">
                                        <div className="d-flex gap-2 align-items-center">
                                            <Field name="captcha" type="text" maxLength="5" className="form-control" placeholder="Enter Captcha" />
                                            <div
                                                style={{
                                                    background: "#f0f0f0",
                                                    padding: "6px 10px",
                                                    borderRadius: "4px",
                                                    minWidth: "110px",
                                                }}
                                            >
                                                {captcha && <img src={captcha} alt="Captcha" width="100%" height="40px" />}
                                            </div>
                                            <button type="button" className="btn btn-outline-secondary" onClick={GetCaptcha} title="Refresh Captcha">
                                                <TfiReload size={16} />
                                            </button>
                                        </div>
                                        <ErrorMessage name="captcha" className="text-danger" component="div" />
                                    </div>

                                    {/* Submit */}
                                    <button type="submit" className="btn btn-success w-100 mt-1" disabled={formik.isSubmitting} style={{ background: selectedCourse?.btn, border: "none" }}>
                                        {formik.isSubmitting ? "Signing In..." : `Sign In to ${selectedCourse?.name || ""} Portal`}
                                    </button>

                                    {/* Forgot Password */}
                                    {/* <div className="text-center mt-2">
                                        <span
                                            role="button"
                                            tabIndex={0}
                                            onClick={() => navigate("/ForgotPassword")}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter" || e.key === " ") navigate("/ForgotPassword");
                                            }}
                                            style={{ cursor: "pointer", color: "#0d6efd", fontSize: "0.85rem" }}
                                        >
                                            Forgot Password?
                                        </span>
                                    </div> */}
                                </Form>
                            </FormikProvider>
                        </affl.Modal.Body>
                    </affl.Modal>

                    {/* <affl.Modal show={showImageModal} onHide={handleCloseImageModal} backdrop={false} keyboard={false} size="lg">
                        <affl.Modal.Body
                            style={{
                                padding: "30px",
                                position: "relative",
                                maxWidth: "850px",
                                backgroundColor: "#f9f9f9",
                                borderRadius: "10px",
                                boxShadow: "0 10px 28px rgba(0,0,0,0.28)",
                            }}
                        >
                            <button
                                onClick={handleCloseImageModal}
                                style={{
                                    position: "absolute",
                                    top: "-12px",
                                    right: "-12px",
                                    width: "34px",
                                    height: "34px",
                                    borderRadius: "50%",
                                    backgroundColor: "#1565C0",
                                    color: "#fff",
                                    border: "none",
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                    boxShadow: "0px 2px 6px rgba(0,0,0,0.3)",
                                }}
                            >
                                ✕
                            </button>
                            {console.log("showNote", showNote, "showImageModal", showImageModal)}
                            {showNote && showImageModal && (<>
                                <div
                                    style={{
                                        fontSize: "16px",
                                        lineHeight: "1.7",
                                        backgroundColor: "#fff3cd",
                                        padding: "18px",
                                        borderRadius: "8px",
                                        borderLeft: "6px solid #ff9800",
                                        fontWeight: "500",
                                        color: "#333",
                                    }}
                                >
                                    <strong style={{ color: "#d32f2f", fontSize: "17px" }}>🔔 NOTE:</strong>
                                    <br />
                                    <br />
                                    🔵 NOC services for New/change/conversion of programmes, Change in name of institution, Closure of institution will be available shortly.
                                </div>


                                <div className="mt-4">
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                            marginBottom: "15px",
                                        }}
                                    >
                                        <h5
                                            style={{
                                                fontWeight: "bold",
                                                color: "#1565C0",
                                                margin: 0,
                                            }}
                                        >
                                            {showNote
                                                ? "GOs & Guidelines"
                                                : "Notifications & Guidelines"}
                                        </h5>

                                        <img
                                            src="/new-icon.gif"
                                            alt="New"
                                            style={{
                                                height: "40px",
                                                width: "40px",
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>

                                    <div
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                                            gap: "12px",
                                        }}
                                    >
                                        {pdfButtons.map((btn, index) => (
                                            <button
                                                key={index}
                                                onClick={() => window.open(btn.file, "_blank")}
                                                style={{
                                                    ...btnStyle,
                                                    backgroundColor: btn.bg,
                                                    color: btn.color,
                                                    border: `1px solid ${btn.border}`,
                                                }}
                                            >
                                                {btn.label}
                                            </button>
                                        ))}
                                        {buttonsToShow.map((btn, index) => (
                                            <button
                                                key={index}
                                                onClick={() => window.open(btn.file, "_blank")}
                                                style={{
                                                    ...btnStyle,
                                                    backgroundColor: btn.bg,
                                                    color: btn.color,
                                                    border: `1px solid ${btn.border}`,
                                                }}
                                            >
                                                {btn.label}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </>)}


                        </affl.Modal.Body>
                    </affl.Modal> */}

                    <affl.Modal
                        show={showImageModal}
                        onHide={handleCloseImageModal}
                        backdrop={false}
                        keyboard={false}
                        size="lg"
                    >
                        <affl.Modal.Body style={{
                            padding: "30px",
                            position: "relative",
                            maxWidth: "850px",
                            backgroundColor: "#f9f9f9",
                            borderRadius: "10px",
                            boxShadow: "0 10px 28px rgba(0,0,0,0.28)",
                        }}>

                            {/* Close Button */}
                            <button
                                onClick={handleCloseImageModal}
                                style={{
                                    position: "absolute",
                                    top: "-12px", right: "-12px",
                                    width: "34px", height: "34px",
                                    borderRadius: "50%",
                                    backgroundColor: "#1565C0",
                                    color: "#fff", border: "none",
                                    fontSize: "16px", fontWeight: "bold",
                                    cursor: "pointer",
                                    boxShadow: "0px 2px 6px rgba(0,0,0,0.3)",
                                }}
                            >
                                ✕
                            </button>


                            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "15px" }}>
                                <h5 style={{ fontWeight: "bold", color: "#1565C0", margin: 0 }}>
                                    {modalMode === "gos" ? "GOs" : modalMode === "notifications" ? "Notifications & Guidelines" : "Note"}
                                </h5>
                                <img src="/new-icon.gif" alt="New"
                                    style={{ height: "40px", width: "40px", objectFit: "contain" }} />
                            </div>
                            {/* 
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                                gap: "12px",
                            }}>

                                {buttonsToShow.map((btn, index) => (
                                    <button
                                        key={index}
                                        onClick={() => window.open(btn.file, "_blank")}
                                        style={{
                                            ...btnStyle,
                                            backgroundColor: btn.bg,
                                            color: btn.color,
                                            border: `1px solid ${btn.border}`,
                                        }}
                                    >
                                        {btn.label}
                                    </button>
                                ))}

                            </div> */}
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                }}
                            >
                                {buttonsToShow.map((btn, index) => (
                                    <button
                                        key={index}
                                        onClick={() => btn.file && window.open(btn.file, "_blank")}
                                        disabled={!btn.file}
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            width: "100%",
                                            padding: "14px 18px",
                                            borderRadius: "10px",
                                            border: `1px solid ${btn.border || "#ddd"}`,
                                            background: btn.bg || "#fff",
                                            color: btn.color || "#333",
                                            cursor: btn.file ? "pointer" : "default",
                                            transition: "0.2s",
                                            fontSize: "15px",
                                            fontWeight: 500,
                                            textAlign: "left",
                                        }}
                                        onMouseEnter={(e) => {
                                            if (btn.file) {
                                                e.currentTarget.style.transform = "translateY(-2px)";
                                                e.currentTarget.style.boxShadow =
                                                    "0 4px 12px rgba(0,0,0,0.15)";
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = "translateY(0)";
                                            e.currentTarget.style.boxShadow = "none";
                                        }}
                                    >
                                        <span
                                            style={{
                                                flex: 1,
                                                whiteSpace: "pre-line",
                                            }}
                                        >
                                            {btn.label}
                                        </span>

                                        {btn.file && (
                                            <span
                                                style={{
                                                    fontSize: "20px",
                                                    marginLeft: "15px",
                                                }}
                                                title="Download"
                                            >
                                                ⬇️
                                            </span>
                                        )}
                                    </button>
                                ))}
                            </div>
                        </affl.Modal.Body>
                    </affl.Modal>

                    <affl.Modal
                        show={showAbout}
                        onHide={() => setShowAbout(false)}
                        size="lg"
                        centered
                        className="about-modal"
                    >
                        <affl.Modal.Header closeButton className="about-header">
                            <h5>About Us</h5>
                        </affl.Modal.Header>

                        <affl.Modal.Body className="about-body">

                            <h6 className="about-title">About NOC Portal</h6>

                            <p>
                                The NOC Portal of Andhra Pradesh, under the supervision of the Commissionerate
                                of Collegiate Education Andhra Pradesh, is an integrated online platform developed
                                to facilitate the processing and management of permissions, approvals, and
                                regulatory compliances for educational institutions across the state.
                            </p>

                            <p>
                                The portal streamlines the submission, verification, and approval process related
                                to establishment and operation of colleges and academic institutions.
                            </p>

                            <p>
                                The portal enables institutions to submit applications and upload required documents for various academic and administrative purposes
                            </p>
                            <h6 className="about-subtitle">Key Functional Areas</h6>


                            <ul className="about-list">
                                <li><span>College establishment permissions and approvals</span></li>
                                <li><span>Introduction of new courses and additional intake</span></li>
                                <li><span>Staff and faculty details verification</span></li>
                                <li><span>Bank corpus fund verification</span></li>
                                <li><span>Laboratory and infrastructure details</span></li>
                                <li><span>Classroom availability and capacity verification</span></li>
                                <li><span>Building safety and lease/rental documents</span></li>
                                <li><span>Registration certificates and statutory approvals</span></li>
                                <li><span>Affiliation-related documentation</span></li>
                                <li><span>Compliance reports and supporting records</span></li>
                            </ul>

                            <p>
                                The system is designed to ensure transparency, accuracy, and efficient coordination
                                between educational institutions, universities, and the concerned government departments.
                            </p>

                            <p>
                                Through digital verification and document management, the portal reduces manual
                                processing time and improves administrative efficiency.
                            </p>

                            <p className="about-footer-text">
                                The NOC Portal supports institutions in maintaining compliance with government
                                regulations and academic standards while providing a secure and user-friendly
                                environment for online application processing, monitoring, and approval workflows
                                under the guidance of the Commissionerate of Collegiate Education, Andhra Pradesh.
                            </p>

                        </affl.Modal.Body>
                    </affl.Modal>


                    <div className="aphe-logo-emblem">
                        <img src="../images/MAINLOGO.png" alt="logo" />
                    </div>

                    <div className="aphe-logo-text">
                        <h1>Commissionerate of Higher Education</h1>
                        {/* <p>Higher Education Department, A.P</p> */}
                        <p>Government of Andhra Pradesh</p>

                    </div>
                </div>

                <nav className="aphe-nav">


                    <nav className="aphe-nav">
                        {NAV_LINKS.map((l) => {
                            if (l === "Affiliation 2026 - 27") {
                                return (
                                    <button
                                        key={l}
                                        className="aphe-nav-link"
                                        onClick={() => window.open(
                                            "https://affiliation.apcfss.in/",
                                            "_blank",
                                            "noopener,noreferrer"
                                        )}
                                        style={{
                                            background: "linear-gradient(45deg, #28a745, #20c997)",
                                            color: "#fff",
                                            border: "none",
                                            padding: "6px 16px",
                                            borderRadius: "8px",
                                            fontWeight: "600",
                                            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                                            transition: "0.3s",
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.transform = "scale(1.05)";
                                            e.target.style.boxShadow = "0 4px 12px rgba(0,0,0,0.3)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.transform = "scale(1)";
                                            e.target.style.boxShadow = "0 2px 8px rgba(0,0,0,0.2)";
                                        }}
                                    >
                                        🚀 {l}
                                    </button>
                                );
                            }

                            return (
                                <button
                                    key={l}
                                    className="aphe-nav-link"
                                    onClick={() => {
                                        if (l === "Notifications") {
                                            // setShowImageModal(true);
                                            // setShowNote(false);
                                            setModalMode("notifications");   // ✅ Notifications on click
                                            setShowImageModal(true);
                                        }
                                        if (l === "Website Policies") {
                                            window.open(
                                                "/CHE_Website_Policy.pdf",
                                                "_blank",
                                                "noopener,noreferrer"
                                            );
                                        }
                                        if (l === "About") {
                                            setShowAbout(true);
                                        }
                                        if (l === "Go's") {
                                            setModalMode("gos");
                                            setShowImageModal(true);
                                        }
                                    }}
                                >
                                    {l}
                                </button>
                            );
                        })}

                        <button
                            type="button"
                            onClick={() => handleLogin("university")}
                            className="aphe-nav-link aphe-nav-btn"
                        >
                            Admin Login
                        </button>

                        <button
                            type="button"
                            onClick={() => handleLogin("inspection")}
                            className="btn btn-secondary"
                        >
                            Inspection Login
                        </button>
                    </nav>
                </nav>
            </header>

            <Ticker />

            <div className="aphe-hero">
                <div className="aphe-hero-inner">
                    <div className="aphe-hero-content">
                        <h2>Commissionerate of Higher Education</h2>
                        <p>
                            The Commissionerate of Higher Education (CHE) oversees and regulates higher education institutions in the state, ensuring quality standards in teaching, research, and administration.
                        </p>
                    </div>
                    <div className="aphe-hero-stats">
                        {STATS.map((s, i) => (
                            <div key={s.label} style={{ display: "flex", gap: 32, alignItems: "center" }}>
                                <div className="aphe-stat">
                                    <div className="aphe-stat-num">{s.num}</div>
                                    <div className="aphe-stat-label">{s.label}</div>
                                </div>
                                {i < STATS.length - 1 && <div className="aphe-stat-divider" />}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="aphe-section-header">
                <h3 className="aphe-section-title">
                    <span className="aphe-title-bar" />
                    Select Your Programme
                </h3>



                {/* 
                <span
                    className="aphe-section-badge"
                    role="button"
                    tabIndex={0}
                    onClick={() => navigate("/NewCollegeRegister")}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            navigate("/NewCollegeRegister");
                        }
                    }}
                    style={{
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                    }}
                >
                    <img
                        src="/new-icon.gif"
                        alt="New"
                        style={{
                            height: "30px",
                            width: "30px",
                            objectFit: "contain",
                        }}
                    />

                    Click here Register New College
                </span> */}

            </div>

            <div className="aphe-cards-grid">
                {COURSES?.map((course) => (
                    <CourseCard key={course.key} course={course} onLogin={handleLogin}
                    // onRegister={handleRegister} 
                    />
                ))}
            </div>

            <affl.Container fluid>
                <div className="downloads-notices1">
                    <div className="info-container1">

                        <affl.Row className="align-items-stretch contact-row">

                            {/* LEFT SIDE - ABOUT US */}
                            <affl.Col xs={12} md={6} className="d-flex">
                                <div className="about-us-card w-100">

                                    <h4>About Us</h4>

                                    <div className="address-block">
                                        <h5>Registered Address</h5>
                                        <p>
                                            BRKR BHAVAN,<br />
                                            Adharsh Nagar,<br />
                                            Tank Bund, Hyderabad - 500063
                                        </p>
                                    </div>

                                    <div className="address-block">
                                        <h5>Current Address</h5>
                                        <p>
                                            GARUDADRI K K Towers,<br />
                                            D.No. 11-1307,<br />
                                            Mangalagiri, Guntur District,<br />
                                            Andhra Pradesh - 522503
                                        </p>
                                    </div>

                                </div>

                            </affl.Col>


                            <affl.Col xs={12} md={6} className="map-container">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15308.204534790833!2d80.54761707162426!3d16.42222925069605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35f7990cb34b73%3A0xd8b6512be41a17d4!2sCommissionerate%20of%20Higher%20Education%2C%20Garudadri%20KK%20Towers%2C%20Mangalagiri!5e0!3m2!1sen!2sin!4v1778753812272!5m2!1sen!2sin"
                                    width="600"
                                    height="450"
                                    className="homepage-map"
                                    style={{ border: 0 }}
                                    allowFullScreen
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="APCFSS Location"
                                />
                            </affl.Col>

                        </affl.Row>

                    </div>
                    <small style={{ color: "black", fontFamily: "monospace" }}>
                        Last updated : {__BUILD_TIME__}
                    </small>
                </div>
            </affl.Container >
            <footer className="aphe-footer text-center">
                <p
                    style={{ color: "white" }}
                    className="mb-0 footer-text"
                >
                    Designed and Developed by  &emsp;
                    <a
                        href="https://apcfss.in/"
                        target="_blank"
                        rel="noreferrer"
                        className="footer-link"
                    >
                        <img
                            src="../images/footer-logo.svg"
                            alt="APCFSS"
                            className="img-fluid footer-logo"
                        />
                    </a>
                </p>
            </footer>
        </div >
    );
}
